<template>
  <div
    class="modal modal-custom-style"
    :id="id"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`${id}-aria-label`"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="title"> <!-- header show/hide temporary based on `title` props, will enhanced to configurate via props (eg `showHeader`) when there is more configurate option in header -->
          <h5
            class="modal-title">
            {{ title }}
          </h5>
          <!-- Didn't implement action buttons for header -->
        </div>

        <component
          v-if="component"
          :is="component"
          v-bind="componentProps"
          v-on="componentEvents"/>

        <div class="modal-footer" v-if="actions.length > 0"> <!-- footer show/hide temporary based on `actions` props, will enhance to configurate via props (eg `showFooter`) when there is more configurate option in footer -->
          <button v-for="(action, index) in actions"
            :key="index"
            :type="action?.type ?? 'button'"
            :class="['btn btn-secondary', action?.class]"
            @click="() => action?.clickFn?.()">
            {{ action?.text ?? 'Action Button' }}
          </button>
        </div>
      </div>
    </div>

    <!-- v-if="visible" -->
    <div
      class="modal-backdrop fade show"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: {
    id: {
      type: String,
      required: true,
    },
    title: String,
    component: [Object, Function],
    componentProps: {
      type: Object,
    },
    componentEvents: {
      type: Object,
    },
    actions: {
      type: Array,
      default: () => [],
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/app.scss';
.modal-custom-style {
  display: block; // hack
  overflow: hidden; // hack?
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $normal-font-color;
}
.modal-content {
  max-height: 500px; // fallback
  max-height: calc(80vh); // 60% of viewport height
}
.modal-content > :nth-child(1) { // we wont know the 1st child root tag is which tag so need to use nth-child to always select first direct child
  overflow-y: auto;
}
</style>
